/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEmbedYoutubeData } from './embed-youtube.data';
import { IEmbedYoutubeProps, IVideoDetailsData } from './embed-youtube.props.autogenerated';

export interface IEmbedYoutubeViewProps extends IEmbedYoutubeProps<IEmbedYoutubeData> {
    videos: IVideoDetailsData[];
}

/**
 *
 * EmbedYoutube component
 * @extends {React.PureComponent<IEmbedYoutubeProps<IEmbedYoutubeData>>}
 */
class EmbedYoutube extends React.PureComponent<IEmbedYoutubeProps<IEmbedYoutubeData>> {
    public render(): JSX.Element | null {
        const { config } = this.props;
        const viewProps = {
            ...this.props,
            videos: config.videos
        };
        return this.props.renderView(viewProps);
    }
}

export default EmbedYoutube;
